'use client';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import BrandsHero from './BrandsHero';
import BrandSearch from './BrandSearch';
import InfiniteContent from '@/components/general/InfiniteContent';
import { ResponseType, brand } from '@/commonTypes';
import Api from '@/api';
import BlogCard from '../../home/HomeContent/SampleBlogs/BlogCard';
import BrandCard from './BrandCard';
import { mapBrand } from '@/functions/mapApiData';
interface ContentType {
  data?: ResponseType<brand>;
  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
  country?: string;
  modelCount?: number;
  blogCount?: number;
}

export default function BrandsContent({
  country,
  data,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
  modelCount = 0,
  blogCount = 0,
}: ContentType) {
  const items = (data?.response || []).map(mapBrand);
  const totalCount = (data as any)?.count ?? 0;
  const [pageNumber, setPageNumber] = useState(page ? page : 1);
  const [list, setList] = useState({ response: items });

  useEffect(() => {
    setList({ response: (data?.response || []).map(mapBrand) });
  }, [data]);

  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);
  console.log('params====', params);
  console.log('data====', data);

  return (
    <>
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <PageHero className={` ${styles.bottomPadding}`}>
            <BrandsHero brandCount={totalCount} modelCount={modelCount} blogCount={blogCount} />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>

      <PageWrapper className={`w-full section-light pt-0 mt-0`}>
        <ViewportWrapper className={`container`}>
          <BrandSearch
            country={country || ''}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
          />
        </ViewportWrapper>
        <div className={`container py-0`}>
          {items && items?.length != 0 ? (
            <InfiniteContent
              page={page}
              params={params}
              initialList={{ response: items, response_details: { count: totalCount } }}
              list={list}
              setList={setList}
              limit={limit}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              apiCall={Api.brandList}
              gridClass={` ${styles.posts_grid}`}
              renderItem={(item, index) => <BrandCard item={item} key={index} index={index} />}
              urlQuery={true}
              emptyText={`هیچ برندی با فیلترهای شما مطابقت ندارد.`}
            ></InfiniteContent>
          ) : (
            <p className={`card notFound `}>برند یافت نشد.</p>
          )}
        </div>
      </PageWrapper>
    </>
  );
}
